module.exports = __webpack_public_path__ + "assets/normal/images/logo-white.8d1b8d54.png";